// extracted by mini-css-extract-plugin
module.exports = {"cardBody":"_2rKwMOUWaMl3GaDG5yWvY0","card":"_3rKY6h8hbIqcTnbGN_vS_h","cardContent":"_23Omy0B5ZVx1DBBa8ainm5"};